<template>
  <v-container style="max-width: 1800px !important">
    <v-row v-if="show">

      <v-col col="12">
        <v-row class="ma-0 pa-0" align="center">
          <v-col cols="12" md="4">
            <v-switch
              v-model="searchItem.solo_sin_asignar"
              :label="`Solo Interpretaciones sin Asignar: ${searchItem.solo_sin_asignar ? 'Si' : 'No'}`"
              :loading="loading"
              :disabled="loading"
              @change="getItems"
            ></v-switch>
          </v-col>
          <template v-if="!searchItem.solo_sin_asignar">
            <v-col cols="12" md="4">
              <RadiologoSelect
                v-model="searchItem.id_radiologo"
                :items="radiologos"
                @input="getItems"
                :loading="loading || loadingRadiologos"
                :disabled="loading || loadingRadiologos"
              />
            </v-col>
            <v-col cols="12" md="4">
              <v-autocomplete
                v-model="searchItem.id_tecnico_radiologo"
                label="Técnico Radiólogo"
                :items="tecnicos_radiologos"
                item-text="nombre"
                item-value="id_usuario"
                clearable
                dense
                hide-details
                outlined
                :loading="loadingTecnicosRadiologos"
                :disabled="loadingTecnicosRadiologos"
                @change="getItems"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="6">
              <v-autocomplete
                v-model="searchItem.id_unidad_medica"
                label="Unidad Médica"
                :items="unidades_medicas"
                item-value="id_unidad_medica"
                item-text="nombre"
                clearable
                dense
                hide-details
                outlined
                :loading="loading"
                :disabled="loading"
                @change="getItems"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                v-model.lazy="searchItem.folio_servicio"
                label="Folio Servicio"
                clearable
                dense
                hide-details
                outlined
                :loading="loading"
                :disabled="loading"
              ></v-text-field>
            </v-col>
          </template>
        </v-row>
      </v-col>

      <v-col cols="12" v-if="selected_interpretations?.length > 0">
        <v-row class="ma-0 pa-0" align="center">
          <!-- Mensaje -->
          <v-col cols="12" md="4">
            {{ selected_interpretations.length }} Interpretaciones han sido seleccionadas. Asignar a:
          </v-col>

          <!-- Select -->
          <v-col cols="12" md="5">
            <RadiologoSelect
              v-model="id_usuario_multiple_assign"
              :items="radiologos"
              :loading="loadingRadiologos"
              :disabled="loadingRadiologos"
            />
          </v-col>

          <!-- Botón -->
          <v-col cols="12" md="3">
            <v-btn color="primary" block :disabled="!id_usuario_multiple_assign" @click="asignarInterpretaciones">
              Asignar
            </v-btn>
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="12">
        <v-data-table
          v-model="selected_interpretations"
          :loading="loading"
          :items="items"
          :headers="headers"
          show-select
          checkbox-color="primary"
          hide-default-footer
          :items-per-page="-1"
          item-key="id_paciente_servicio"
        >
          <template v-slot:[`item.id_usuario`]="{ item }">
            <RadiologoSelect
              v-model="item.id_usuario"
              :items="radiologos"
              :loading="loadingRadiologos"
              :disabled="loadingRadiologos"
            >
            </RadiologoSelect>
          </template>
        </v-data-table>
      </v-col>
      <v-col cols="12">
        <v-btn
          color="primary"
          block
          class="white--text"
          :disabled="anyAssigned || saving"
          :loading="saving"
          @click="guardarInterpretaciones"
        >
          <v-icon>mdi-content-save</v-icon>
          Guardar Asignación de Médicos Radiólogos
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from "axios";
import RadiologoSelect from './RadiologoSelect.vue';
import _ from 'lodash';

export default {
  components:{
    RadiologoSelect
  },
  mounted() {
    this.getRadiologos();
    this.getItems();
    this.getTecnicosRadiologos();
    this.getUnidadesMedicas();
  },
  data: () => ({
    headers: [
      { 
        text: "Folio",
        value: "folio",
        align: 'center',
        width: "11%"
      },
      { 
        text: "Nombre",
        value: "nombre",
        align: 'center',
        width: "11%"
      },
      { 
        text: "Apellido Paterno",
        value: "apellido_paterno",
        align: 'center',
        width: "11%"
      },
      { 
        text: "Apellido Materno",
        value: "apellido_materno",
        align: 'center',
        width: "11%"
      },
      { 
        text: "Fecha del Estudio",
        value: "realizado",
        align: 'center',
        width: "10%"
      },
      { 
        text: "Técnico Radiólogo",
        value: "tecnico_radiologo",
        align: 'center',
        width: "11%"
      },
      { 
        text: "Unidad Médica",
        value: "nombre_unidad_medica",
        align: 'center',
        width: "10%"
      },
      { 
        text: "Radiólogo",
        value: "id_usuario",
        align: 'center',
        width: "25%",
      },
    ],
    radiologos: [],
    loadingRadiologos: false,
    loading: false,
    items: [],
    selected_interpretations: [],
    id_usuario_multiple_assign: null,
    show: true,
    saving: false,
    searchItem: {
      solo_sin_asignar: true,
      id_radiologo: null,
      id_tecnico_radiologo: null,
      id_unidad_medica: null,
      folio_servicio: null
    },
    loadingUnidadesMedicas: false,
    unidades_medicas: [],
    loadingTecnicosRadiologos: false,
    tecnicos_radiologos: []
  }),
  computed: {
    anyAssigned() {
      if (!Array.isArray(this.items) || this.items.length === 0) return false;

      // Devuelve true si al menos uno tiene id_usuario asignado
      return !this.items.some(x => x.id_usuario != null);
    }
  },
  methods: {
    getRadiologos() {
      this.loadingRadiologos = true;
      axios
        .get("/ConsultasMastografias/ListarRadiologos")
        .then((response) => {
          this.radiologos = response.data;
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.loadingRadiologos = false;
        });
    },
    getItems(){
      this.loading = true;
      
      if(this.searchItem.solo_sin_asignar){
        this.searchItem.id_radiologo = null;
        this.searchItem.id_tecnico_radiologo = null;
        this.searchItem.id_unidad_medica = null;
        this.searchItem.folio_servicio = null;
      }

      const url = new URL(`http://localhost/ConsultasMastografias/InterpretacionesSinAsignar`);
      url.searchParams.append("solo_sin_asignar", this.searchItem.solo_sin_asignar);
      if(this.searchItem.id_radiologo != null) url.searchParams.append("id_radiologo", this.searchItem.id_radiologo);
      if(this.searchItem.id_tecnico_radiologo != null) url.searchParams.append("id_tecnico_radiologo", this.searchItem.id_tecnico_radiologo);
      if(this.searchItem.id_unidad_medica != null) url.searchParams.append("id_unidad_medica", this.searchItem.id_unidad_medica);
      if(this.searchItem.folio_servicio != null) url.searchParams.append("folio_servicio", this.searchItem.folio_servicio);
      
      var url_string = url.href.replace('http://localhost', '');
      
      axios
        .get(url_string)
        .then((response) => {
          this.items = response.data;
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    asignarInterpretaciones() {
      this.show = false;
      this.selected_interpretations.forEach((selected) => {
        const item = this.items.find(i => i.id_paciente_servicio === selected.id_paciente_servicio);
        if (item) {
          item.id_usuario = this.id_usuario_multiple_assign;
        }
      });

      this.selected_interpretations = [];
      this.id_usuario_multiple_assign = null;
      setTimeout(() => {
        this.show = true;
      }, 50)
    },
    guardarInterpretaciones(){
      this.saving = true;
      var asignaciones = [];
      
      this.items.forEach(i => {
        if(i.id_usuario != null){
          asignaciones.push({
            id_paciente_servicio: i.id_paciente_servicio,
            id_usuario: i.id_usuario   
          });
        }
      });

      axios
      .post('ConsultasMastografias/AsignarInterpretacion', {
        asignaciones: asignaciones
      })
      .then(() => {
        this.selected_interpretations = [];
        this.id_usuario_multiple_assign = null;
        this.getItems();
      })
      .catch(error => {
        console.log(error);
      })
      .finally(() => {
        this.saving = false;
      })
    },
    debouncedFolioInput: _.debounce(function() {
      this.getItems();
    }, 1000),
    getUnidadesMedicas(){
      this.loadingUnidadesMedicas = true;
      axios
      .get('/Catalogos/ListarUnidadesMedicas?solo_mastografia=true')
      .then(response => {
        this.unidades_medicas = response.data;
      })
      .catch(error => {
        console.log(error);
      })
      .finally(() => {
        this.loadingUnidadesMedicas = false;
      })
    },
    getTecnicosRadiologos(){
      this.loadingTecnicosRadiologos= true;
      axios
      .get('/ConsultasMastografias/GetTecnicosRadiologos')
      .then(response => {
        this.tecnicos_radiologos = response.data;
      })
      .catch(error => {
        console.log(error);
      })
      .finally(() => {
        this.loadingTecnicosRadiologos = false;
      })
    }


  },
  watch: {
    'searchItem.folio_servicio': function () {
      this.debouncedFolioInput();
    }
  }
};
</script>